import React, { Component } from 'react';
import Toggle from 'react-toggle';
import Loader from 'react-loader';
import DropzoneType from './DropzoneType';
import Results from './Results';
import rocketLogo from './assets/rocket-spike.png';
import coinbaseForm from './assets/coinbase-new-form.png';
import './Toggle.css';
import './DropForm.css';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fifo: true,
      files: [],
      submittable: false,
      results: null,
      loading: false,
      error: null,
    };
  }

  handleAddCSV = file => {
    const newFiles = this.state.files.concat(file);

    this.setState({
      files: newFiles,
      submittable: !!newFiles.length,
    });
  };

  handleFifoChange = e => {
    this.setState({ fifo: !this.state.fifo });
  };

  handleSubmit = async e => {
    e.preventDefault();

    // build up form data
    let data = new FormData();
    this.state.files.forEach(function(value, index) {
      data.append(`coin_csv${index}`, value);
    });
    data.append('fifo', this.state.fifo);

    // reset local state
    this.setState({
      files: [],
      submittable: false,
      error: null,
      loading: true,
    });

    try {
      const response = await fetch(
        // 'http://localhost:3001/api/v1/trades',
        'https://moontax-staging.herokuapp.com/api/v1/trades',
        {
          method: 'POST',
          body: data,
        }
      );

      const results = await response.json();
      this.setState({ results, loading: false });
    } catch (error) {
      console.log('∆∆∆ error', error);
      this.setState({ error, loading: false });
    }
  };

  renderResults() {
    if (this.state.loading) {
      return <Loader position="relative" loaded={false} color="white" />;
    } else if (this.state.results) {
      return <Results data={this.state.results} />;
    } else {
      return <div className="no-results">Form values will appear here.</div>;
    }
  }

  render() {
    return (
      <div className="dropform">
        <div className="dropform__intro">
          <div className="intro__one">
            Moon Tax is a <span className="highlight">free</span> service to
            help you file taxes in the US.
          </div>
          <div className="intro__two">
            Currently it only supports Coinbase users.{' '}
            <a href="#faq" onClick={this.learnMore}>
              Learn more.
            </a>
          </div>
        </div>

        <img src={rocketLogo} className="break__logo" alt="rocket-logo" />
        <hr className="break" />

        <div className="dropzone__container">
          <div className="step-instruction">
            <div className="step-instruction__number">Step 1.</div>
            Download your buy/sell history for each coin.{' '}
            <button
              className="step-instruction__button"
              onClick={() =>
                this.setState({ showStepOne: !this.state.showStepOne })}
            >
              {this.state.showStepOne ? 'Hide details' : 'Learn how'}
            </button>
            {this.state.showStepOne &&
              <div className="step-instruction__details">
                You'll need your transaction history for each coin you've
                purchased. Within the Coinbase website, navigate to Tools, then
                Reports, then select New Report.
                <br />
                <br />
                In the New Report form, select "Buys, sells, and merchant
                payments" as the type and "All history" for the time range.
                Repeat this step for each coin you've owned.
                <img
                  src={coinbaseForm}
                  className="step-instruction__img"
                  alt="form-example"
                />
              </div>}
          </div>

          <div className="step-instruction">
            <div className="step-instruction__number">Step 2.</div>
            Upload each CSV file.
            <div className="step-instruction__secondary">
              (Ignore boxes for coins you've never owned.)
            </div>
          </div>

          <form onSubmit={this.handleSubmit}>
            <div className="dropform__container">
              <DropzoneType type="BTC" handleSubmit={this.handleAddCSV} />
              <DropzoneType type="BCH" handleSubmit={this.handleAddCSV} />
              <DropzoneType type="ETH" handleSubmit={this.handleAddCSV} />
              <DropzoneType type="LTC" handleSubmit={this.handleAddCSV} />
            </div>

            <div className="step-instruction">
              <div className="step-instruction__number">Step 3.</div>
              Select a reporting method: FIFO or LIFO.
            </div>

            <label>
              <div className="dropform__reporting-method">
                {this.state.fifo ? 'FIFO' : 'LIFO'}
              </div>
              <Toggle
                id="fifo-toggle"
                className="toggle"
                icons={false}
                checked={this.state.fifo}
                onChange={this.handleFifoChange}
              />
            </label>

            <div className="step-instruction">
              <div className="step-instruction__number">Step 4.</div>
              Generate the report.
            </div>
            <button
              disabled={!this.state.submittable}
              className="dropform__submit-button"
            >
              submit
            </button>
          </form>

          {this.state.error &&
            <div className="error">
              Whoops! Something went wrong. Try again later.
            </div>}

          <div className="step-instruction">
            <div className="step-instruction__number">Step 5.</div>
            Fill in your 8949 tax form.
          </div>
          {this.renderResults()}
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/DropForm.js